import type { CartLineItem } from '@/stores/use-cart-store';
import type { CreateBillItemDto } from '@/services/billing.service';

type CartLine = Pick<CartLineItem, 'productId' | 'quantity' | 'unitPrice' | 'listPrice' | 'discountAmount'>;

/**
 * A cart line as `POST /bills` reads it. The server prices the line from the
 * catalogue, so the add-ons the cashier chose — folded into `unitPrice` above the
 * catalogue `listPrice` — travel as `modifier_surcharge`; without it the bill is
 * stored at the bare catalogue price while the cart showed the add-ons.
 */
export function toBillItem(item: CartLine): CreateBillItemDto {
  const surcharge = item.listPrice !== undefined ? item.unitPrice - item.listPrice : 0;
  return {
    product_id: item.productId,
    quantity: item.quantity,
    ...(item.listPrice !== undefined ? { expected_unit_price: item.listPrice } : {}),
    ...(surcharge > 0 ? { modifier_surcharge: surcharge } : {}),
    // POST /bills reads a flat per-line `discount` in paise (it snapshots price
    // server-side). The cart already computed discountAmount from the line's
    // %/flat discount — send that so combo/manual discounts reach the bill total.
    ...(item.discountAmount > 0 ? { discount: item.discountAmount } : {}),
  };
}
